import { render, staticRenderFns } from "./editorVideo.vue?vue&type=template&id=ad6711c0&"
import script from "./editorVideo.vue?vue&type=script&lang=js&"
export * from "./editorVideo.vue?vue&type=script&lang=js&"
import style0 from "./editorVideo.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports